import React, { HTMLAttributes } from 'react';
import cn from 'classnames';
import css from './Error.module.css';

const Error = (props: HTMLAttributes<HTMLDivElement>) => (
  <div {...props} data-selector="error" className={cn(css.error, props.className)} />
);

export default Error;
